import { snackbarAdd, snackbarClear } from "actions/snackbars";
import { Snackbar } from "reducers/snackbars";
import { getStore } from "store";

interface ISnackbarDescriptor extends Snackbar {
    action?: string;
    autoHideDuration?: number;
}

interface ISnackbar {
    show: {
        (message: string): void;
        (descriptor: Partial<ISnackbarDescriptor>): void;
    };
    clear: () => void;
}

export const snackbar: ISnackbar = {
    show: (descriptorOrMessage: string | Partial<ISnackbarDescriptor>) => {
        const descriptor =
            typeof descriptorOrMessage === "string" ? { message: descriptorOrMessage } : descriptorOrMessage;

        const store = getStore();
        store.dispatch(snackbarAdd(descriptor));
    },
    clear: () => {
        const store = getStore();
        store.dispatch(snackbarClear());
    },
};
